<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19zge9q/tc-custom/9780061740459.jpg?1728851645598" alt="This image is the cover for the book Clara Callan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Clara Callan
      </h1>
      <p class="bookDescription body article font2">
        <p>In a small town in Canada, Clara Callan reluctantly takes leave of her sister, Nora, who is bound for New York. It's a time when the growing threat of fascism in Europe is a constant worry, and people escape from reality through radio and the movies. Meanwhile, the two sisters -- vastly different in personality, yet inextricably linked by a shared past -- try to find their places within the complex web of social expectations for young women in the 1930s.</p><p>While Nora embarks on a glamorous career as a radio-soap opera star, Clara, a strong and independent-minded woman, struggles to observe the traditional boundaries of a small and tight-knit community without relinquishing her dreams of love, freedom, and adventure. However, things aren't as simple as they appear -- Nora's letters eventually reveal life in the big city is less exotic than it seems, and the tranquil solitude of Clara's life is shattered by a series of unforeseeable events. These twists of fate require all of Clara's courage and strength, and finally put the seemingly unbreakable bond between the sisters to the test.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard B. Wright
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1eeb058